import { Component } from "react";
import LocalizedStrings from 'react-localization';
import en from '../i18n/en.json';
import de from '../i18n/de.json';
import ar from '../i18n/ar.json';

class I18n extends Component{
    localizedStrings = (key) => {
        var strings = new LocalizedStrings({
            en:en,
            de:de,
            ar:ar
        });
        return strings[key]
    }
}
export default I18n;